import React from 'react';
import { Box } from '@material-ui/core';

function ProgressBar(props) {
    const {
        title,
        maxValue,
        minValue,
        valueNow,
    } = props;


    return (<Box>
        <div className="align-box mb-1">
            <div>
                <small className="font-weight-bold">
                   {title}
                    </small>
            </div>
        </div>
        <div className="progress w-100 " style={{backgroundColor : "#e1e2e8", height:"0.5rem"}}>
            <div
                aria-valuemax={maxValue}
                aria-valuemin={minValue}
                aria-valuenow={valueNow}
                className="progress-bar bg-success"
                role="progressbar" style={{width: `${valueNow}%`}}></div>
        </div>
        <div className="align-box-row progress-bar--label mt-1 text-muted">
            <small className="text-dark">{minValue}</small>
            <small className="ml-auto">{maxValue}%</small>
        </div>
    </Box>
    );
}

ProgressBar.defaultProps = {
    title: "",
    maxValue: "100",
    minValue: "0",
    valueNow: "100",
}

export default ProgressBar;

